import React from 'react'
import tw, { styled } from 'twin.macro'
import { Link } from 'gatsby'
//import { useForm } from 'react-hook-form'

//import { A11y, Navigation } from 'swiper'
//import { Swiper, SwiperSlide } from 'swiper/react';

import Card from './card'

//import 'swiper/css';
//import 'swiper/css/navigation';


const OfferGrid = ({ headingWeight = 'h2', headingText, r: { offers }, site = process.env.GATSBY_SITE, ...props }) => {
    if(!offers) {
        return;
    }

    offers = offers.map(offer => ({
        ...offer,
        link: offer.override?.path ? offer.override?.path.replace(`/${site}/`, '/') : offer.path.alias.replace(`/${site}/`, '/')
    }))

    return (
        <Style id={`offer-grid-${props.pid}`} className="content-slice promotion offer-grid">
            <div className="content-slice__container">
                {offers.length && (
                    <ul className="offer-grid__slides" data-slides={offers.length}>
                        {offers.map((offer,i) => (
                            <li key={i}>
                                <Card join_link={site === 'residential' ? '/join' : '/request-call'} {...offer} />
                            </li>
                        ))}
                    </ul>
                )}

            </div>
        </Style>
    )
}
export default OfferGrid


const Style = styled.section`

    header + & {
        ${tw `mt-20!`}
    }

    > .content-slice__container {
        ${tw `w-full xl:container mx-auto px-4 relative`}
    }


    .offer-grid__slides {
        ${tw `flex flex-wrap justify-center list-none mx-auto gap-y-8`}

        &:has(.offer-grid__promotional-offer) {
            ${tw `gap-y-14`}
        }

        > li {
            ${tw `w-full md:w-1/2 xl:w-full xl:flex-1 mb-0`}
            max-width: 450px;
        }

        ~ button {
            ${tw `hidden!`}
        }
    }

    & + .content-slice--prose .prose {
        ${tw `mt-20 text-neutral-600`}
    }

    & :where(.with-gst, .without-gst) > span {
        ${tw `hidden`}
    }

    .without-gst {
        ${tw `hidden`}
    }

    .with-gst > span {
        ${tw `hidden`}
    }

    .offer-grid-switch[data-gst="excl"] ~ & {

        .without-gst {
            ${tw `block`}

            span {
                ${tw `inline`}
            }
        }

        .with-gst {
            ${tw `hidden!`}
        }
    }

    .offer-grid-switch[data-gst="incl"] ~ & {

        .without-gst {
            ${tw `hidden!`}
        }

        .with-gst {
            ${tw `block`}



            span {
                ${tw `inline`}
            }
        }
    }
`
